import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'itemsLimitReachedText', 'currentItemsSelectedCountNumber', 'currentItemsSelectedCountContainer' ]
  static values = {
    itemsLimit: Number,
    currentItemsCount: Number,
  }
  initialize() {
    window.asset_ids_by_type = {};
    this.currentItemsSelectedCountNumber = 0;
  }

  handleAddButtonClick(event) {
    const itemsToAdd = window.asset_ids_by_type ? Object.values(window.asset_ids_by_type).flat().length : 1;
    if (this.itemsLimitValue && this.currentItemsCountValue + itemsToAdd  > this.itemsLimitValue) {
      if (this.hasItemsLimitReachedTextTarget) {
        this.itemsLimitReachedTextTarget.classList.remove('hidden');
      }
      event.preventDefault();
      event.stopPropagation();
      return false;
    } else {
      if (this.hasItemsLimitReachedTextTarget) {
        this.itemsLimitReachedTextTarget.classList.add('hidden');
      }
    }
  }

  handleSelectAllAssets(event) {
    const checkboxes = document.querySelectorAll('input[name=add_batch]');
    const isChecked = event.target.checked;
    if (!isChecked) {
      if (this.hasItemsLimitReachedTextTarget) {
        this.itemsLimitReachedTextTarget.classList.add('hidden');
      }
    }
   
    checkboxes.forEach(checkbox => {
      checkbox.checked = isChecked;
    });
    
    this.handleAddMultipleCheck();
  }

  handleAddMultipleCheck() {
    const checkedCheckboxes = document.querySelectorAll('input[name=add_batch]:checked');
    const allCheckboxes = document.querySelectorAll('input[name=add_batch]');
    
    const allTypes = Array.from(allCheckboxes).map(checkbox => checkbox.dataset.assetType).filter((type, index, self) => type && self.indexOf(type) === index);

    allTypes.forEach(type => {
      window.asset_ids_by_type[type] = [];
      Array.from(checkedCheckboxes).forEach(checkbox => {
        if (checkbox.dataset.assetType === type) {
          window.asset_ids_by_type[type].push(checkbox.value);
        }
      });
    });

    const totalSelectedItems = Object.values(window.asset_ids_by_type).flat().length;
    
    if (this.hasCurrentItemsSelectedCountNumberTarget) {
      this.currentItemsSelectedCountNumberTarget.textContent = totalSelectedItems;
    }
    
    const hasSelection = totalSelectedItems > 0;

    if (this.hasCurrentItemsSelectedCountContainerTarget) {
      hasSelection ? this.currentItemsSelectedCountContainerTarget.classList.remove('hidden') : this.currentItemsSelectedCountContainerTarget.classList.add('hidden');
    }

    this.updateAssetContainerStates(hasSelection);
    this.updateBatchActionButtons();
  }

  updateAssetContainerStates(hasSelection) {
    const assetInfoContainers = document.querySelectorAll('.asset-info-container');

    assetInfoContainers.forEach(container => {
      const addBatchButton = container.querySelector('.add-batch-asset-btn');
      const addButton = container.querySelector('.add-asset-btn');
      const assetId = container.getAttribute('data-asset-id');
      const checkboxInput = container.querySelector('input[name=add_batch]');
      
      // Skip containers without a checkbox
      if (!checkboxInput) {
        return;
      }
      
      const assetType = checkboxInput.dataset.assetType;
      const isSelected = window.asset_ids_by_type[assetType]?.includes(assetId) ?? false;

      if (!hasSelection) {
        // Nothing selected - return to default state (opacity-0 with hover effect)
        container.classList.remove('opacity-50');
        addBatchButton?.classList.remove('opacity-100');
        addBatchButton?.classList.add('hidden', 'opacity-0');
        addButton?.classList.remove('hidden');
      } else if (isSelected) {
        // This item is selected - show it with opacity-100
        container.classList.remove('opacity-50');
        addBatchButton?.classList.remove('hidden', 'opacity-0');
        addBatchButton?.classList.add('opacity-100');
        addButton?.classList.add('hidden');
      } else {
        // Something is selected but not this item - gray it out
        container.classList.add('opacity-50');
        addBatchButton?.classList.add('hidden', 'opacity-0');
        addBatchButton?.classList.remove('opacity-100');
        addButton?.classList.add('hidden');
      }
    });
  }

  updateBatchActionButtons() {
    const batchAddLinks = document.querySelectorAll('.add-batch-asset-btn');

    batchAddLinks.forEach(link => {
      const url = new URL(link.href);
      Object.keys(window.asset_ids_by_type).forEach(type => {
        url.searchParams.set(type, window.asset_ids_by_type[type]);
      });
      link.href = url;
    });
  }

  toggleCheckbox(event) {
    const clickedElement = event.target;
    const isClickableElement = clickedElement.matches('button, a, input, [role="button"]') || clickedElement.closest('button, a, input, [role="button"]');
    const container = event.target.closest('.asset-info-container');
    
    if (isClickableElement || !container) {
      return; 
    }
    
    const checkbox = container.querySelector('input[type="checkbox"][name="add_batch"]');
    
    if (checkbox && !checkbox.disabled) {
      event.stopPropagation();
      checkbox.checked = !checkbox.checked;
      this.handleAddMultipleCheck();
    }
  }
}